import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	aiNote: {
		backgroundColor: colors.purple[50],
		border: `1px solid ${colors.purple[200]}`,
		borderRadius: 11,
		padding: "12px 14px",
		display: "flex",
		alignItems: "flex-start",
		gap: 10
	},
	aiNoteIconBox: {
		width: 30,
		height: 30,
		minWidth: 30,
		borderRadius: 8,
		backgroundColor: colors.purple[400],
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexShrink: 0
	},
	aiNoteIcon: {
		width: 16,
		height: 16,
		"& path": {
			fill: colors.gray[0]
		}
	},
	aiNoteText: {
		flex: 1,
		fontSize: 12.5,
		fontWeight: 400,
		lineHeight: 1.45,
		color: colors.gray[600]
	}
}))

export default useStyles
